var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BulletLineWidget',{attrs:{"title":_vm.$t('product.pam.asset.conditions.widget.pre-compression-force.title'),"current-value":_vm.preCompressionForce,"unit":_vm.$t('product.pam.asset.conditions.widget.pressure.unit'),"ranges":_vm.ranges}})}
var staticRenderFns = []

export { render, staticRenderFns }